import React, { useState, useEffect, useRef } from "react";
import LocationCards from "../../shared/locationCards/LocationCards";

const MobileLocationSearch = ({ place, handlePlaceInputChange }) => {
  const [showDrawer, setShowDrawer] = useState(false); // Drawer visibility
  const [filteredLocations, setFilteredLocations] = useState([]); // Filtered locations
  const dropdownRef = useRef(null); // Ref for the dropdown container

  // Close the drawer when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDrawer(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchCitySuggestions = async (query) => {
    // eslint-disable-next-line no-undef
    const service = new google.maps.places.AutocompleteService();
    service.getPlacePredictions(
      {
        input: query,
        types: ["geocode"], // Use geocode for broader results, including localities
        componentRestrictions: { country: "in" }, // Restrict to India
      },
      (predictions, status) => {
        // eslint-disable-next-line no-undef
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          // Filter predictions where "Bengaluru" exists in the "terms" array
          const bangaloreLocations = predictions.filter((prediction) =>
            prediction.terms.some(
              (term) => term.value.toLowerCase() === "bengaluru"
            )
          );

          if (bangaloreLocations.length > 0) {
            const suggestions = bangaloreLocations.map(
              (prediction) => prediction.description
            );
            setFilteredLocations(suggestions);
          } else {
            // If no Bengaluru results, show custom message
            setFilteredLocations([
              "Bangalore is our first love. But don’t worry, we’re ready to start a long-distance relationship soon! ❤️",
            ]);
          }
        } else {
          // Handle no results or API errors
          setFilteredLocations([
            "Bangalore is our first love. But don’t worry, we’re ready to start a long-distance relationship soon! ❤️",
          ]);
        }
      }
    );
  };

  const handleInputChange = (e) => {
    handlePlaceInputChange(e); // Call the parent handler
    const value = e.target.value;
    if (value.trim()) {
      fetchCitySuggestions(value); // Fetch city suggestions
    } else {
      setFilteredLocations([]); // Clear suggestions for empty input
    }
    setShowDrawer(true); // Ensure drawer stays open while typing
  };

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Input Field */}
      <div
        className=""
        onClick={() => setShowDrawer(!showDrawer)} // Toggle drawer
      >
        <input
          className="mobile-search-text-fiels w-input mob-border-btm-0-imp"
          maxLength={256}
          value={place}
          onChange={(e) => handleInputChange(e)}
          placeholder="Search location"
          type="text"
        />
        {/* <input
          id="name-2"
          type="text"
          name="name-2"
          value={place}
          onChange={(e) => handleInputChange(e)}
          placeholder="Search Location"
          className="navbar_form--textfield w-input"
          autoComplete="off"
          maxLength={256}
          required=""
        /> */}
        <div className="placeholder">Where are you going to?</div>
      </div>

      {/* Drawer */}
      {showDrawer && (
        <div className="absolute top-full left-0 right-0 pb-5 w-80 bg-white rounded-2xl shadow-lg mt-2">
          <ul className="max-h-66 overflow-auto pt-5">
            {filteredLocations.length > 0 ? (
              filteredLocations.map((location, index) => (
                <li
                  key={index}
                  onClick={() => {
                    if (!location.includes("Bangalore is our first love")) {
                      handlePlaceInputChange({ target: { value: location } }); // Select location
                      setShowDrawer(false); // Close drawer
                    }
                  }}
                >
                  <LocationCards
                    location={location}
                    showIcon={!location.includes("Bangalore is our first love")}
                  />
                </li>
              ))
            ) : (
              <li className="px-4 py-2 text-gray-500">No locations found</li>
            )}
          </ul>
          {/* <LocationSvg /> */}
        </div>
      )}
    </div>
  );
};

export default MobileLocationSearch;
